import React from "react";
import classNames from "classnames";
import "./UserInterestList.scss";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import Tooltip from "src/app/components/Tooltip/Tooltip";
import { ReactComponent as DotsIcon } from "src/images/settings-horizontal.svg";

function List({ list, selectedInterest }) {
  return (
    <div className="interest-content">
      {list?.map((interest) => (
        <div
          key={interest.name}
          className={classNames("interest", {
            "interest--selected":
              selectedInterest?.indexOf(interest.value) > -1,
          })}
        >
          <IDHFormattedMessage
            id={interest.name}
            defaultMessage={interest.value}
          />
        </div>
      ))}
    </div>
  );
}

function UserInterestList({ interestList, selectedInterest, visibleLimit }) {
  let list = interestList ? [...interestList] : [];
  if (visibleLimit) {
    list = list?.slice(0, visibleLimit);
  }

  return (
    <div className="interest-wrapper">
      <List list={list} selectedInterest={selectedInterest} />

      {visibleLimit >= 0 && interestList?.length > visibleLimit && (
        <Tooltip
          up
          clickable
          autoSize
          content={
            <List list={interestList} selectedInterest={selectedInterest} />
          }
          contentClassName="interest-wrapper__tooltip-content"
        >
          <button className="interest-wrapper__button" type="button">
            <DotsIcon />
          </button>
        </Tooltip>
      )}
    </div>
  );
}

export default UserInterestList;
